import functions from "../../../../../world/spa/libs/vuexFunctions";

export default {
  namespaced: true,
  state: {
    objs: []
  },
  getters: {
    ...functions.createDefaultGetters(["idWorldPlace"])
  },
  mutations: {
    ...functions.createDefaultMutations(["idWorldPlace"])
  },
  actions: {
    ...functions.createDefaultActionsWithStore(["idWorldPlace"])
  }
};
